export enum FormQuestionType {
  textInput = 'textInput',
  multipleSelection = 'multipleSelection',
  dropDown = 'dropDown',
  checkbox = 'checkbox',
  dateInput = 'dateInput',
  timeInput = 'timeInput',
  ratingInput = 'ratingInput',
  textBlock = 'textBlock',
  signatureInput = 'signatureInput',
}

export type FormQuestion = {
  type: FormQuestionType;
  prompt: string;
  options?: string[];
  defaultValue?: boolean;
  maxValue?: string;
  minValue?: string;
};

export type FormContent = {
  formName: string;
  introMessage?: string;
  questions: FormQuestion[];
};
